module.exports = __webpack_public_path__ + "static/media/promotion03.dcfcabe7.jpg";